document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-icon .card-image a, .card-icon .card-title a').forEach((elem) => {
    elem.addEventListener('mouseover', () => {
      elem.closest('.card-icon').classList.add('hover');
    })
    elem.addEventListener('mouseout', () => {
      elem.closest('.card-icon').classList.remove('hover');
    })
  })
})